import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config';
import { COLLECTIONS } from '../collections';

interface EditedImageData {
  originalImageUrl: string;
  editedImageUrl: string;
  prompt: string;
  createdAt: Date;
  metadata?: {
    type: string;
    timestamp: number;
  };
}

export async function saveEditedImage(userId: string, data: EditedImageData): Promise<void> {
  try {
    if (!userId) throw new Error('User ID is required');
    if (!data.editedImageUrl) throw new Error('Edited image URL is required');

    const editedRef = collection(db, COLLECTIONS.EDITED);
    await addDoc(editedRef, {
      userId,
      ...data,
      createdAt: serverTimestamp(),
      metadata: {
        type: 'edit',
        timestamp: Date.now(),
        originalImage: data.originalImageUrl
      }
    });
  } catch (error) {
    console.error('Error saving edited image:', error);
    throw error;
  }
}